import { OrderContentType } from '@/interface/order';

export enum PlatformItems {
  TWITTER = 'twitter',
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  YOUTUBE = 'youtube',
  LINKEDIN = 'linkedin',
  GOOGLE = 'google',
  FACEBOOK = 'facebook'
}

export enum PlatformContentEnum {
  YOUTUBE_DEDICATED = 'youtubeDedicated',
  YOUTUBE_INTEGRATED = 'youtubeIntegrated',
  TIKTOK_VIDEO = 'tiktokVideo',
  INSTAGRAM_REEL = 'instagramReel',
  INSTAGRAM_CAROUSEL_POST = 'instagramCarouselPost',
  LINKEDIN_POST = 'linkedinPost',
  LINKEDIN_IMAGE_POST = 'linkedinImagePost',
  LINKEDIN_VIDEO_POST = 'linkedinVideoPost',
  TWITTER_POST = 'twitterPost'
}

export const getPlatformContentLabelI18n = (key: string, t?: any) => {
  return {
    [PlatformContentEnum.YOUTUBE_DEDICATED]: t(
      'common.contentType.youtubeDedicated'
    ),
    [PlatformContentEnum.YOUTUBE_INTEGRATED]: t(
      'common.contentType.youtubeIntegrated'
    ),
    [PlatformContentEnum.TIKTOK_VIDEO]: t('common.contentType.tiktokVideo'),
    [PlatformContentEnum.INSTAGRAM_REEL]: t('common.contentType.instagramReel'),
    [PlatformContentEnum.INSTAGRAM_CAROUSEL_POST]: t(
      'common.contentType.instagramCarouselPost'
    ),
    [PlatformContentEnum.TWITTER_POST]: t('common.contentType.twitterPost'),
    [PlatformContentEnum.LINKEDIN_POST]: t('common.contentType.linkedinPost'),
    [PlatformContentEnum.LINKEDIN_IMAGE_POST]: t(
      'common.contentType.linkedinImagePost'
    ),
    [PlatformContentEnum.LINKEDIN_VIDEO_POST]: t(
      'common.contentType.linkedinVideoPost'
    )
  }[key];
};

// linkedin 的两种类型
export enum LinkedInContentType {
  POST = 'Post', // 一开始用的类型，后来细分成下面的类型，用来兼容老数据
  IMAGE_TEXT = 'Image & Text',
  VIDEO = 'Video'
}
// linkedin 的两种类型对应的标签
export const LinkedInContentTypeLabel = {
  [LinkedInContentType.POST]: 'LinkedIn post', // 兼容旧数据
  [LinkedInContentType.IMAGE_TEXT]: 'LinkedIn image posts',
  [LinkedInContentType.VIDEO]: 'LinkedIn video posts'
};

// 用来使用订单内的数据，与设置的价格之间的对应关系
export const BasePriceKeyListMap: Record<
  string,
  Record<string, PlatformContentEnum | undefined>
> = {
  [PlatformItems.INSTAGRAM.toLowerCase()]: {
    [OrderContentType.REELS]: PlatformContentEnum.INSTAGRAM_REEL,
    [OrderContentType.POST]: PlatformContentEnum.INSTAGRAM_CAROUSEL_POST
  },
  [PlatformItems.YOUTUBE.toLowerCase()]: {
    [OrderContentType.DEDICATED_VIDEO]: PlatformContentEnum.YOUTUBE_DEDICATED,
    [OrderContentType.INTEGRATED_VIDEO]: PlatformContentEnum.YOUTUBE_INTEGRATED
  },
  [PlatformItems.TIKTOK.toLowerCase()]: {
    [OrderContentType.VIDEO]: PlatformContentEnum.TIKTOK_VIDEO
  },
  [PlatformItems.LINKEDIN.toLowerCase()]: {
    [OrderContentType.POST]: PlatformContentEnum.LINKEDIN_POST,
    [OrderContentType.VIDEO]: PlatformContentEnum.LINKEDIN_VIDEO_POST
  },
  [PlatformItems.TWITTER.toLowerCase()]: {
    [OrderContentType.POST]: PlatformContentEnum.TWITTER_POST
  }
};
